import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default class OriginalInsightsRoute extends PermittedRoute {
  permission = 'insights';
}
